<div class="admin-dashboard">
  <!-- Welcome Section -->
  <div class="welcome-section">
    <div class="welcome-content">
      <h1>Welcome back, {{ currentUser?.name }}! 👋</h1>
      <p>Here's what's happening with your business today.</p>
    </div>
    <div class="welcome-actions">
      <!-- <button class="btn btn-primary">
        <i class="fas fa-plus"></i>
        Add New Product
      </button> -->
      <!-- <button class="btn btn-outline-primary">
        <i class="fas fa-download"></i>
        Export Report
      </button> -->
      <button class="btn btn-outline-secondary" (click)="refreshDashboard()" [disabled]="isLoading">
        <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
        {{ isLoading ? 'Refreshing...' : 'Refresh' }}
      </button>
      <!-- <button class="btn btn-outline-primary" (click)="testToasts()">
        <i class="fas fa-bell"></i>
        Test Toasts
      </button> -->
    </div>
  </div>

  <!-- Quick Actions -->
  @if (!isLoading) {
  <div class="quick-actions">
    <div class="action-card">
      <div class="action-header">
        <h3>Quick Actions</h3>
      </div>
      <div class="action-buttons">
        <button class="action-btn" routerLink="/admin/orders">
          <i class="fas fa-eye"></i>
          View Orders
        </button>
        <button class="action-btn" routerLink="/admin/products">
          <i class="fas fa-plus"></i>
          Add Product
        </button>
        <button class="action-btn" routerLink="/admin/categories">
          <i class="fas fa-tags"></i>
          Manage Categories
        </button>
        <button class="action-btn" routerLink="/admin/users">
          <i class="fas fa-user-plus"></i>
          View Customers
        </button>
        <button class="action-btn" routerLink="/admin/reports">
          <i class="fas fa-chart-bar"></i>
          View Reports
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Dashboard Content with Graph -->
  @if (!isLoading) {
  <div class="dashboard-content">
    <div class="content-grid">
      <!-- Recent Orders -->
      <div class="content-card">
        <div class="card-header">
          <h3>Recent Orders</h3>
          <a routerLink="/admin/orders" class="view-all">View All</a>
        </div>
        <div class="card-content">
          @if (recentOrders.length > 0) {
          <div class="order-list">
            @for (order of recentOrders; track order.id) {
            <div class="order-item">
              <div class="order-info">
                <div class="order-id">{{ order.id }}</div>
                <div class="customer-name">{{ order.customerName }}</div>
                <div class="order-date">{{ formatDate(order.date) }}</div>
              </div>
              <div class="order-actions">
                <span class="order-amount">{{ formatCurrency(order.amount) }}</span>
                <span class="order-status" [style.background-color]="getStatusColor(order.status)">
                  {{ order.status | titlecase }}
                </span>
              </div>
            </div>
            }
          </div>
          } @else {
          <div class="empty-state">
            <i class="fas fa-shopping-cart fa-2x"></i>
            <p>No orders found</p>
            <small>Orders will appear here once they are placed</small>
          </div>
          }
        </div>
      </div>

      <!-- Orders Graph for Regular Admins -->
      @if (!isSuperAdmin) {
      <div class="content-card">
        <div class="card-header">
          <h3>Orders Overview (Last 7 Days)</h3>
          <span class="date-range">{{ getLast7DaysRange() }}</span>
        </div>
        <div class="card-content">
          <div class="orders-graph">
            <div class="graph-container">
              <div class="graph-bar pending" [style.height]="getBarHeight(ordersGraphData.pending)">
                <div class="bar-label">{{ ordersGraphData.pending }}</div>
                <div class="bar-title">Pending</div>
              </div>
              <div class="graph-bar shipped" [style.height]="getBarHeight(ordersGraphData.shipped)">
                <div class="bar-label">{{ ordersGraphData.shipped }}</div>
                <div class="bar-title">Shipped</div>
              </div>
              <div class="graph-bar delivered" [style.height]="getBarHeight(ordersGraphData.delivered)">
                <div class="bar-label">{{ ordersGraphData.delivered }}</div>
                <div class="bar-title">Delivered</div>
              </div>
            </div>
            <div class="graph-legend">
              <div class="legend-item">
                <span class="legend-color pending"></span>
                <span>Pending</span>
              </div>
              <div class="legend-item">
                <span class="legend-color shipped"></span>
                <span>Shipped</span>
              </div>
              <div class="legend-item">
                <span class="legend-color delivered"></span>
                <span>Delivered</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }

      <!-- Top Products for Super Admin Only -->
      @if (isSuperAdmin) {
      <div class="content-card">
        <div class="card-header">
          <h3>Top Performing Products</h3>
          <a routerLink="/admin/products" class="view-all">View All</a>
        </div>
        <div class="card-content">
          @if (topProducts.length > 0) {
          <div class="product-list">
            @for (product of topProducts; track product.id; let i = $index) {
            <div class="product-item">
              <div class="product-rank">#{{ i + 1 }}</div>
              <div class="product-info">
                <div class="product-name">{{ product.name }}</div>
                <div class="product-sales">{{ product.sales }} units sold</div>
              </div>
              <div class="product-revenue">{{ formatCurrency(product.revenue) }}              </div>
            </div>
            }
          </div>
          } @else {
          <div class="empty-state">
            <i class="fas fa-box fa-2x"></i>
            <p>No products found</p>
            <small>Products will appear here once they are added</small>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Statistics Cards -->
  @if (!isLoading) {
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon orders">
        <i class="fas fa-shopping-cart"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.totalOrders }}</h3>
        <p>Total Orders</p>
        <span class="stat-change" [ngClass]="getOrderGrowthClass()">
          <i [class]="getOrderGrowthIcon()"></i>
          {{ getOrderGrowthPercentage() }}% from last month
        </span>
      </div>
    </div>

    @if (isSuperAdmin) {
    <div class="stat-card">
      <div class="stat-icon revenue">
        <i class="fas fa-rupee-sign"></i>
      </div>
      <div class="stat-content">
        <h3>{{ formatCurrency(dashboardStats.totalRevenue) }}</h3>
        <p>Total Revenue</p>
        <span class="stat-change" [ngClass]="getRevenueGrowthClass()">
          <i [class]="getRevenueGrowthIcon()"></i>
          {{ getRevenueGrowthPercentage() }}% from last month
        </span>
      </div>
    </div>
    }

    <div class="stat-card">
      <div class="stat-icon users">
        <i class="fas fa-users"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.totalUsers }}</h3>
        <p>Total Customers</p>
        <span class="stat-change" [ngClass]="getUserGrowthClass()">
          <i [class]="getUserGrowthIcon()"></i>
          {{ getUserGrowthPercentage() }}% from last month
        </span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon products">
        <i class="fas fa-box"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.totalProducts }}</h3>
        <p>Active Products</p>
        <span class="stat-change neutral">
          <i class="fas fa-minus"></i>
          {{ getProductChangeStatus() }}
        </span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon pending">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.pendingOrders }}</h3>
        <p>Pending Orders</p>
        <span class="stat-change negative">
          <i class="fas fa-exclamation"></i>
          {{ getPendingOrdersStatus() }}
        </span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon completed">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.completedOrders }}</h3>
        <p>Completed Orders</p>
        <span class="stat-change" [ngClass]="getCompletedOrdersClass()">
          <i [class]="getCompletedOrdersIcon()"></i>
          {{ getCompletedOrdersStatus() }}% from last month
        </span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon low-stock">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.lowStockProducts }}</h3>
        <p>Low Stock Items</p>
        <span class="stat-change negative">
          <i class="fas fa-arrow-down"></i>
          {{ getLowStockStatus() }}
        </span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon growth">
        <i class="fas fa-chart-line"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.totalOrders > 0 ? Math.round((dashboardStats.completedOrders / dashboardStats.totalOrders) * 100) : 0 }}%</h3>
        <p>Success Rate</p>
        <span class="stat-change positive">
          <i class="fas fa-arrow-up"></i>
          {{ getSuccessRateStatus() }}
        </span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon efficiency">
        <i class="fas fa-tachometer-alt"></i>
      </div>
      <div class="stat-content">
        <h3>{{ dashboardStats.totalProducts > 0 ? Math.round((dashboardStats.totalProducts - dashboardStats.lowStockProducts) / dashboardStats.totalProducts * 100) : 0 }}%</h3>
        <p>Stock Health</p>
        <span class="stat-change positive">
          <i class="fas fa-arrow-up"></i>
          {{ getStockHealthStatus() }}
        </span>
      </div>
    </div>
  </div>
  }

  <!-- Loading State -->
  @if (isLoading) {
  <div class="loading-state">
    <div class="spinner"></div>
    <p>Loading dashboard data...</p>
  </div>
  }

  <!-- Error State -->
  @if (hasError && !isLoading) {
  <div class="error-state">
    <div class="error-content">
      <i class="fas fa-exclamation-triangle fa-2x"></i>
      <h3>Something went wrong</h3>
      <p>{{ errorMessage }}</p>
              <button class="btn btn-primary" (click)="refreshDashboard()">
          <i class="fas fa-redo"></i>
          Try Again
        </button>
      </div>
    </div>
  }
</div> 